import { transformCurrencyAmountDtoOrString } from '@marketplace-web/domain/currency-data'

import { OfferDto, OfferModel } from '../types/offer'

export const transformOfferDto = ({ id, price, currency }: OfferDto): OfferModel => ({
  id,
  price: transformCurrencyAmountDtoOrString(price, currency),
})
